export default __webpack_public_path__ + "static/media/pathNode.79b1b915.PNG";